import * as React from "react";
import { IconProps } from "./IconProps";

export const IconUser = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4C10.6193 4 9.5 5.11929 9.5 6.5C9.5 7.88071 10.6193 9 12 9C13.3807 9 14.5 7.88071 14.5 6.5C14.5 5.11929 13.3807 4 12 4ZM7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5ZM5.67838 19H18.3216C17.6127 16.0911 15.2304 14 12 14C8.76965 14 6.38732 16.0911 5.67838 19ZM3.50439 19.9064C3.91665 15.5211 7.24222 12 12 12C16.7578 12 20.0834 15.5211 20.4956 19.9064C20.522 20.1867 20.429 20.465 20.2395 20.6732C20.05 20.8814 19.7815 21 19.5 21H4.5C4.21851 21 3.95005 20.8814 3.76055 20.6732C3.57104 20.465 3.47805 20.1867 3.50439 19.9064Z"
          fill={color}
        />
      </svg>
    );
  }
);
